import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { API_BASE_URL_WITHOUT_API } from '../config/api';
import './PartnerShell.css';

const logoSrc = (logoUrl) => {
  if (!logoUrl) return '';
  return /^https?:\/\//.test(logoUrl) ? logoUrl : `${API_BASE_URL_WITHOUT_API}${logoUrl}`;
};

/**
 * Frame for the partner pages (/list-your-property and /owner): a slim top
 * bar with the brand and one action, then the page content. Keeps both pages
 * looking like one journey and leaves the phone screen to the content.
 */
const PartnerShell = ({ action, children, wide = false }) => {
  const { companyName, logoUrl } = useSettings();
  const name = companyName || 'WeOtp';

  return (
    <div className="partner-page">
      <header className="partner-bar">
        <Link to="/" className="partner-brand">
          {logoUrl ? (
            <img src={logoSrc(logoUrl)} alt={name} />
          ) : (
            <span className="partner-brand-mark">{name.charAt(0).toUpperCase()}</span>
          )}
          <span className="partner-brand-name">{name}</span>
          <span className="partner-brand-tag">Partners</span>
        </Link>
        {action}
      </header>
      <main className={`partner-content ${wide ? 'partner-content-wide' : ''}`}>{children}</main>
    </div>
  );
};

export default PartnerShell;
